export default __webpack_public_path__ + "static/media/research-02.1873f083.png";